import { useFormikContext } from 'formik';
import { useMemo } from 'react';
import { Row } from 'react-bootstrap';

import FormField from '@components/Form/FormField';
import PhoneField from '@components/Form/PhoneField';
import { IFinancialAssistanceForm } from '@customTypes/requisition';

const ContactInformationFieldSet = () => {
  const { errors } = useFormikContext<IFinancialAssistanceForm>();

  const emailOrPhoneRequired = useMemo(() => !!(errors as Record<string, string>)['email-or-phone'], [errors]);

  return (
    <fieldset className='d-flex flex-column contact-information-fieldset'>
      <legend className='text-center'>Contact Information</legend>
      <p className='mt-2 mb-1 fs-xs text-center'>Provide at least one method to contact you.</p>
      <Row>
        <FormField cols={6} type='email' name='email' inputProps={{ isInvalid: emailOrPhoneRequired }} />
        <PhoneField cols={6} name='phone_number' labelClassName='fs-xs fw-bold' />
      </Row>
    </fieldset>
  );
};

export default ContactInformationFieldSet;
